export function emojiGQLFields() {
    return `
    __typename
    id
    text
  `;
}
//# sourceMappingURL=emoji.fields.js.map